import React, { Component } from "react";
import CardBlock from "./CardBlock";
import Tabs from "../Utils/Tabs";
import CenterBlock from "./CenterBlock";
import { Link, Redirect } from "react-router-dom";
import Constants from "../Utils/Constants";
import APICall from "../Utils/APICall";
import Spinner from "../Utils/Spinner";
import SpinnerButton from "../Utils/SpinnerButton";
import Toastr from "../Utils/Toastr";
import MyTable from "../Utils/MyTable";
import Dropzone from "react-dropzone";
import Modal from "react-modal";
import Functions from "../Utils/Functions";
import Select from "react-select";
import { throttle } from "lodash";
import { DataContext } from "../Contexts/DataContexts";

export default class AbattoirsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: [],
      errorMessage: null,
      searchQuery: "",
      page: 1,
      pageSize: 10,
      modalIsOpen: false,
      uploadErrorMessage: null,
      uploading: false,
      redirect: null,
      user: {},
      alreadyGotResults: false,
    };

    this.RenderTable = this.RenderTable.bind(this);
    this.init = this.init.bind(this);
    this.deleteRecord = this.deleteRecord.bind(this);

    this.throttledReload = throttle(() => {
      this.init(this.state.page, this.state.pageSize, this.state.searchQuery);
    }, 500);
  }

  componentDidMount() {
    Modal.setAppElement("body");
    this.init();
    //        new Functions().whoIsLoggedIn(this.setLoggedInUser, false);
  }

  RenderTable(_data) {
    var headerList = [
      {
        Header: "Name",
        accessor: "nameComponent",
      },
      {
        Header: "Operating Address",
        accessor: "operatingAddress",
      },
      {
        Header: "Phone number",
        accessor: "contactPhone",
      },
      {
        Header: "Country",
        accessor: "country",
      },
      {
        Header: "State",
        accessor: "state",
      },
      {
        Header: "Email",
        accessor: "emailAddress",
      },
      {
        Header: "",
        accessor: "investorsTrigger",
      },
    ];

    _data._data.forEach((element) => {
      let clonedElement = Object.assign({}, element);
      element.nameComponent = (
        <span
          onClick={() => this.props.selectRecord(clonedElement)}
          className="clickable font-weight-bold"
        >
          {element.name}
          <br />
          <span className="text-muted font-weight-normal d-inline-block mt-1">
            Approval number:{" "}
            <span className="text-dark">{element.approvalNumber}</span>
          </span>
        </span>
      );

      element.investorsTrigger = (
        <Link
          style={{ cursor: "pointer" }}
          className="btn btn-xs btn-success btn-rounded"
          to={`/in/investors/${element.id}`}
        >
          Investors
        </Link>
      );
    });

    const tableHeader = React.useMemo(() => headerList, []);

    const tableData = React.useMemo(() => _data, []);
    return (
      <div style={{ zoom: "0.85" }}>
        <MyTable
          columns={tableHeader}
          data={tableData._data}
          enableSearch={true}
        />
      </div>
    );
  }

  deleteRecord(record) {
    this.setState({ loading: true });
    APICall(`api/specializations/removefrommaster/${record.id}`, "POST", {})
      .then((data) => {
        this.setState({ loading: false });
        var response = data.data;
        if (response.status == "success") {
          Toastr("warning", "Record deleted");
          this.init();
        } else {
          Toastr(
            "error",
            "Your request generated an error. Try again after sometime"
          );
        }
        console.log(data);
      })
      .catch((error) => {
        Toastr("error", "Please check your network connection");
        this.setState({ loading: false });
      });
  }
  static contextType = DataContext;

  init(page, pageSize, query) {
    if (!query) query = "";

    this.setState({
      errorMessage: null,
      loading: true,
      searchQuery: query,
      page: page,
      pageSize: pageSize,
    });


    const { globalState, addItem } = this.context;
    this.setState({ profile: globalState?.data })
    const { state, country, userRole } = globalState?.user

    let apiURL = `api/abattoirs/get/${country}/${state}`

    if (userRole == "superadmin") {
      apiURL = "api/abattoirs/list"
    }
    // APICall(`api/abattoirs/get/${country}/${state}`, "GET", {})
    APICall(`${apiURL}`, "GET", {})
      .then((data) => {
        var response = data.data;
        if (response.isSuccess) {
          this.setState({ loading: false, data: null }, () => {
            this.setState({ data: response.data });
          });
        } else {
          this.setState({
            errorMessage:
              "Your request generated an error. Try again after sometime",
            loading: false,
          });
        }
        console.log(data);
      })
      .catch((error) => {
        this.setState({
          errorMessage:
            "Your request generated an error. Please check your network connection",
          loading: false,
        });
      });
  }

  render() {
    return this.state.redirect ? (
      <Redirect to={this.state.redirect} />
    ) : this.state.errorMessage ? (
      <CenterBlock height="150">
        <h1 className="text-danger icon-lg">
          <i className="mdi mdi-alert-circle"></i>
        </h1>
        <div className="text-dark text-center" role="alert">
          An error occurred, you can try reloading the page
        </div>
        <button
          type="button"
          onClick={() => this.init()}
          className="btn btn-inverse-primary btn-fw mt-4 mb-5"
        >
          Reload
        </button>
      </CenterBlock>
    ) : (
      <>
        {this.state.loading ? (
          <div className="text-success" style={{ position: "absolute" }}>
            <Spinner size="1.5" />{" "}
          </div>
        ) : null}

        {!this.state.data ? null : <this.RenderTable _data={this.state.data} />}
      </>
    );
  }
}
